import SectionHeading from "@/pages/home/components/SectionHeading";
import { stories } from "@/mocks/content";

export default function StoriesSection() {
  return (
    <section id="stories" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading
          eyebrow="爱情故事"
          title="别人的故事里，也许有你的答案"
          desc="这些故事来自生活里常见的相遇与相处。它们不一定轰轰烈烈，却藏着很多关系里真实发生过的瞬间。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {stories.map((story) => (
            <article
              key={story.title}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="h-48 w-full sm:h-52">
                <img src={story.img} alt={story.alt} className="h-full w-full object-cover object-top" />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-900">
                    {story.tag}
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                    {story.title}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{story.excerpt}</p>
                <div className="mt-4 flex items-start gap-2 border-t border-background-200 pt-4">
                  <i className="ri-heart-3-line mt-0.5 text-primary-500"></i>
                  <p className="text-xs leading-relaxed text-foreground-600 md:text-sm">{story.takeaway}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}